import React from 'react';
import { FormTab, TextInput, BooleanInput, NumberInput, ReferenceInput, AutocompleteInput, FormDataConsumer, required } from 'react-admin';
import Box from '@mui/material/Box';

import Create from '../common/views/Create';
import TabbedForm from '../common/forms/TabbedForm';
import RichTextInput from '../common/inputs/RichTextInput';
import DateTimeInput from '../common/inputs/DateTimeInput';
import CategoryInput from './inputs/CategoryInput';
import LanguageInput from './inputs/LanguageInput';
import CountryReferenceInput from './inputs/CountryReferenceInput';
import EventMap from './EventMap';

const optionText = choice => choice.name ? choice.name : '';

const EventCreate = props => (
	<Create {...props}>
		<TabbedForm redirect="list">
			<FormTab label="Summary">
				<TextInput source="title" validate={[required()]} fullWidth />
				<LanguageInput label="Default language" validate={[required()]} />
				<CategoryInput />
				<CountryReferenceInput validate={[required()]} />
				<FormDataConsumer>
					{({ formData, ...rest }) => (
						<ReferenceInput label="Region" source="region_id" reference="regions" sort={{ field: 'name', order: 'ASC' }} filter={formData.country_id && { country_id: formData.country_id }} {...rest} validate={[required()]}>
							<AutocompleteInput optionText={optionText} size="small" />
						</ReferenceInput>
					)}
				</FormDataConsumer>
				<DateTimeInput source="start_at" />
				<DateTimeInput source="end_at" />
				<BooleanInput source="is_online" label="Online" />
				<BooleanInput source="is_on_site" label="On site" />
				<FormDataConsumer>
					{({ formData, ...rest }) => (
						formData.is_on_site ? (
							<Box mb={2} width="100%">
								<NumberInput source="lat" {...rest} sx={{ marginRight: '8px' }} />
								<NumberInput source="lng" {...rest} />
								<EventMap formData={formData} />
							</Box>
						) : (
							null
						)
					)}
				</FormDataConsumer>
				<TextInput source="address" multiline rows="4" />
				<TextInput source="organization_name" />
				<TextInput source="organization_website" label="Event website" />
				<TextInput source="organization_contact_info" />
				<TextInput source="intro" multiline rows="4" fullWidth />
				<RichTextInput source="content" />
			</FormTab>
		</TabbedForm>
	</Create>
);

export default EventCreate;
